import React, {FC} from 'react';
import {twMerge} from 'tailwind-merge';

export const Card: FC<{children: React.ReactNode; className?: string}> = ({children, className = ''}) => (
  <div className={twMerge('rounded-lg border border-[#ebecf0] bg-white p-5', className)}>{children}</div>
);

export const SectionTitle: FC<{children: React.ReactNode; className?: string}> = ({children, className = ''}) => (
  <div className={twMerge('mb-3 text-[15px] font-medium text-[#33364b]', className)}>{children}</div>
);
